import { useEffect, useRef } from "react";
import create from "zustand";
export var useGlobalStore = create(function (set, get) {
  return {
    isMobileDrawerOpen: false,
    openMobileDrawer: function openMobileDrawer() {
      return set({
        isMobileDrawerOpen: true
      });
    },
    closeMobileDrawer: function closeMobileDrawer() {
      return set({
        isMobileDrawerOpen: false
      });
    },
    toggleMobileDrawer: function toggleMobileDrawer() {
      var isMobileDrawerOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !get().isMobileDrawerOpen;
      set({
        isMobileDrawerOpen: isMobileDrawerOpen
      });
    },
    isCheatsheetOpen: false,
    openCheatsheet: function openCheatsheet() {
      return set({
        isCheatsheetOpen: true
      });
    },
    closeCheatsheet: function closeCheatsheet() {
      return set({
        isCheatsheetOpen: false
      });
    },
    toggleCheatsheet: function toggleCheatsheet() {
      var isCheatsheetOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !get().isCheatsheetOpen;
      set({
        isCheatsheetOpen: isCheatsheetOpen
      });
    },
    closeModals: function closeModals() {
      set({
        isCheatsheetOpen: false,
        isMobileDrawerOpen: false
      });
    }
  };
});
export function useCheatsheetSyncSetup() {
  var channel = useRef();
  var external = useRef(false);
  var timestamp = useRef(0);
  useEffect(function () {
    if (!("BroadcastChannel" in window)) {
      return function () {};
    }

    if (!channel.current) {
      channel.current = new BroadcastChannel("state-cheatsheet");
    }

    var unsub = useGlobalStore.subscribe(function (state) {
      if (!external.current) {
        var _channel$current;

        timestamp.current = Date.now();
        var data = {
          state: state,
          ts: timestamp.current
        };
        (_channel$current = channel.current) === null || _channel$current === void 0 ? void 0 : _channel$current.postMessage(data);

        if (__DEV__) {
          console.info("POST", data);
        }
      }
    }, function (store) {
      return store.isCheatsheetOpen;
    });

    function handler(_ref) {
      var data = _ref.data;

      if (data.ts > timestamp.current) {
        external.current = true;
        timestamp.current = data.ts;
        useGlobalStore.setState({
          isCheatsheetOpen: Boolean(data.state)
        });
        external.current = false;

        if (__DEV__) {
          console.info("RECV", data);
        }
      }
    }

    channel.current.addEventListener("message", handler);
    return function () {
      var _channel$current2;

      (_channel$current2 = channel.current) === null || _channel$current2 === void 0 ? void 0 : _channel$current2.removeEventListener("message", handler);
      unsub();
    };
  }, []);
  return null;
}